import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiConfig, Path, SiteAdmApiConfig } from '../util/path';
import { Observable } from 'rxjs';
import { Dispensa } from '../modelos/dispensa';
// import { Filtro } from '../paginas/transparencia/licitacoes/aviso-dispensa/aviso-dispensa.component';
import { Setor } from '../modelos/setor';
import { Proposta } from '../modelos/proposta';

@Injectable({
  providedIn: 'root'
})
export class AvisoDispensaService {

  private token: String;

  constructor(private httpClient: HttpClient) {
    this.token = ApiConfig.API_TOKEN;
  }

  private getCabecalho() {
    let cabecalho = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Authorization': 'Bearer ' + this.token,
      })
    };
    return cabecalho;
  }

  buscarRegistros(inicio: number | undefined, quantidade: number | undefined, filtro: Filtro): Observable<Dispensa> {
    let pagina = 0;

    if(inicio && quantidade){
        pagina = Math.floor(inicio/quantidade);
    }

    let url = SiteAdmApiConfig.API_URL +
      `${Path.TRANSPARENCIA.nomeService}/v1/external/contratacao-direta/listarPaginado?pagina=${pagina}&qtd=${quantidade}`;

    if (filtro.filtroSetor) {
      url += `&setor=${filtro.filtroSetor.id}`;
    }

    if (filtro.filtroObjeto) {
      url += `&objeto=${filtro.filtroObjeto}`;
    }

    if (filtro.filtroStatus) {
      url += `&status=${filtro.filtroStatus}`;
    }

    if (filtro.filtroDataLimite) {
      url += `&dataLimite=${filtro.filtroDataLimite.toISOString().substring(0,10)}`;
    }

    if (filtro.filtroProcesso) {
      url += `&processo=${filtro.filtroProcesso}`;
    }

    return this.httpClient.get<Dispensa>(url, this.getCabecalho());
  }

  buscarRegistro(id: number): Observable<Dispensa> {
    let url = SiteAdmApiConfig.API_URL +
    `${Path.TRANSPARENCIA.nomeService}/v1/external/contratacao-direta/` + id;
    return this.httpClient.get<Dispensa>(url, this.getCabecalho());
  }

  listarSetores(): Observable<Setor> {
    let url = SiteAdmApiConfig.API_URL + `${Path.TRANSPARENCIA.nomeService}/v1/external/setor`;
    return this.httpClient.get<Setor>(url, this.getCabecalho());
  }

  enviarProposta(proposta: Proposta) {
    let url = SiteAdmApiConfig.API_URL + `${Path.TRANSPARENCIA.nomeService}/v1/external/proposta`;
    return this.httpClient.post(url, proposta ,this.getCabecalho());
  }

}

//Declarando localmente porque o módulo de aviso de dispensa está oculto.
//Caso o módulo seja exibido novamente na página basta apagar este trecho e descomentar a linha 6
export class Filtro {
  filtroSetor: Setor | undefined = undefined;
  filtroTitulo: string | undefined = undefined;
  filtroObjeto: string | undefined = undefined;
  filtroProcesso: string | undefined = undefined;
  filtroDataLimite: any | undefined = undefined;
  filtroStatus: string | undefined = undefined;
}
